import { render, staticRenderFns } from "./DescreteSelect.vue?vue&type=template&id=4a9ed786&scoped=true"
import script from "./DescreteSelect.vue?vue&type=script&lang=js"
export * from "./DescreteSelect.vue?vue&type=script&lang=js"
import style0 from "./DescreteSelect.vue?vue&type=style&index=0&id=4a9ed786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ed786",
  null
  
)

export default component.exports